import React, { useState } from 'react';
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';
import MyPDFDocument from './pdf/srScalePurePDF';
import { Download, ExternalLink, Loader2 } from 'lucide-react';

// Extracted PDFDownloadButton component
const PDFDownloadButton = ({ result }) => (
  <PDFDownloadLink
    document={<MyPDFDocument result={result} />}
    fileName={`Pension_Case_SrCollege ${result.employeeName.replace(/\s+/g, '_')}.pdf`}
    className="flex-1 w-full"
  >
    {({ loading }) => (
      <button
        disabled={loading}
        className={`w-full flex items-center justify-center gap-2 px-3 py-2 sm:px-4 sm:py-2.5 rounded-md transition-all
          ${loading 
            ? 'bg-gray-100 text-gray-600' 
            : 'bg-blue-600 text-white hover:bg-blue-700 shadow-sm'
          } text-sm font-medium`}
      >
        {loading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <>
            <Download className="h-4 w-4" />
            <span className="hidden xs:inline">Download PDF</span>
            <span className="xs:hidden">Download</span>
          </>
        )}
      </button>
    )}
  </PDFDownloadLink>
);

// Extracted PDFViewButton component
const PDFViewButton = ({ result }) => {
  const [isGenerating, setIsGenerating] = useState(false);

  const handleViewInNewTab = async () => {
    setIsGenerating(true);
    try {
      const pdfDoc = pdf(<MyPDFDocument result={result} />);
      const blob = await pdfDoc.toBlob();
      window.open(URL.createObjectURL(blob), '_blank');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <button
      onClick={handleViewInNewTab}
      disabled={isGenerating}
      className={`flex-1 w-full flex items-center justify-center gap-2 px-3 py-2 sm:px-4 sm:py-2.5 rounded-md transition-all
        ${isGenerating 
          ? 'bg-gray-100 text-gray-600' 
          : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 shadow-sm'
        } text-sm font-medium`}
    >
      {isGenerating ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <>
          <ExternalLink className="h-4 w-4" />
          <span className="hidden sm:inline">View in New Tab</span>
          <span className="sm:hidden">View</span>
        </>
      )}
    </button>
  );
};

// ✅ Export only the two button components
export { PDFDownloadButton, PDFViewButton };
